import { render } from "./TopPage.vue?vue&type=template&id=08744954&scoped=true"
import script from "./TopPage.vue?vue&type=script&lang=js"
export * from "./TopPage.vue?vue&type=script&lang=js"

import "./TopPage.vue?vue&type=style&index=0&id=08744954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08744954"]])

export default __exports__